module.exports = __webpack_public_path__ + "static/media/468x60_0046_ru.86bc3eb2.jpg";